import React from 'react';

const CloudLoader = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',  // Dark transparent background
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,  // High z-index to overlay everything
      color: '#ff00ddff',  // White text for contrast
      fontFamily: 'Arial, sans-serif',  // Professional font
      fontSize: '1.5rem',  // Readable size
      textAlign: 'center',
    }}>
      <span style={{
        animation: 'fadePulse 1.5s infinite ease-in-out',  // Attractive fade-pulse effect
      }}>
        Connecting to server
      </span>
      <style>
        {`
          @keyframes fadePulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default CloudLoader;
